import React, { Component } from 'react'; 
import * as Constants from '../components/api/constants' 
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Copyright from './copyright.component/copyright'
import UsersList from './user.components/UsersList';
import { MainContext } from '../context/MainContext'
import { UserContext } from '../context/UserContext'
export default class Users extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      usersList: undefined,
      spinner: false,
      usersCount: 0
    };
  }

  clearUsersList = () => {
    this.setState({
      usersList: undefined,
      spinner: false
    });
  }

  getUsersList = (email = '', name = '', spa = '', userId = 0, page = 0, sortField = 'id', sortDirection = 'asc') => {
    const requestOptions = {
      method: 'GET', 
      credentials: "include"
    };
    
    const parameters = new URLSearchParams({
      searchEmail: email,
      searchName: name,
      searchSpa: spa,
      searchUserId: userId,
      page: page, 
      pageSize: 10,
      sortField: sortField, 
      sortDirection: sortDirection
    });

    fetch(Constants.baseURL + Constants.apiUsersList + '?' + parameters, requestOptions) 
      .then(response => { 
          if (!response.ok && response.status !== 404) {
              this.props.history.push('/');
          }
          return response.json() })
      .then(data => { 
        this.setState({ 
          usersList: data.users,
          spinner: false,
          usersCount: data.usersCount
        });
      }) 
      .catch(error => { console.log('request failed', error); }); 
  }

  componentDidMount() {
    this._isMounted = true;

    this.setState({
      usersList: undefined,
      spinner: false, 
      usersCount: 0
    })

    this.getUsersList('','', '', 0, 0);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setState = (state,callback)=>{
      return;
    };
  }

  render() {
    return (<Container maxWidth="900px" sx={{ mt: 4, mb: 4 }}>
    <Grid container spacing={3}>
      {/* UsersList */}
      <Grid item xs={12} md={12} lg={12}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                bgcolor: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.08)',
              }}
            >
              <UserContext.Provider value={this.props} >
                <MainContext.Provider value={{
                      usersList: this.state.usersList,
                      usersCount: this.state.usersCount 
                  }}>
                  <UsersList getUsersList={this.getUsersList} clearUsersList={this.clearUsersList} />
                </MainContext.Provider>
              </UserContext.Provider>
            </Paper>
          </Grid>
    </Grid>
    <Copyright sx={{ pt: 4 }} />
  </Container>);
  }
}